import { getSalesforceHiddenFields } from '../Forms/constants'
import type { SalesforceLeadPayload } from '../Forms/submitToSalesforce'
import type { LeadFormConfig, LeadFormField, LeadFormValues } from './types'

type LeadPayloadContext = {
  /** Name of the product page the form is on, for `currentProduct` fields. */
  productName?: string
  /** Today's date as DD/MM/YYYY, for `today` fields. */
  today: string
}

function fieldValue(
  field: LeadFormField,
  values: LeadFormValues,
  { productName, today }: LeadPayloadContext,
): string | undefined {
  if (field.dynamicValue === 'today') return today
  if (field.dynamicValue === 'currentProduct') return productName || undefined
  if (field.type === 'hidden') return field.defaultValue || undefined

  const value = values[field.salesforceName]
  if (typeof value === 'boolean') return value ? '1' : undefined
  return value?.trim() || undefined
}

/** The Web-to-Lead fields to post to Salesforce for a submitted CMS form. */
export function buildLeadPayload(
  form: LeadFormConfig,
  values: LeadFormValues,
  context: LeadPayloadContext,
): SalesforceLeadPayload {
  const payload: SalesforceLeadPayload = {
    ...getSalesforceHiddenFields(form.leadSource),
  }

  form.fields
    .filter(field => field.sendToSalesforce)
    .forEach(field => {
      payload[field.salesforceName] = fieldValue(field, values, context)
    })

  return payload
}
